import React, { useEffect } from "react";
import { Row, Col, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import AOS from "aos";
import "aos/dist/aos.css";
import Title from "../../components/Title/Title";
import "./AboutWebsites.scss";

export default function AboutWebsites() {
  useEffect(() => {
    AOS.init();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="websites_about_page">
      {/* Overview & Approach Section */}
      <section id="websites_about" className="section section-bg py-5">
        <div className="container subpage-container">
          <Row data-aos="fade-down" data-aos-duration="500">
            <Col xs={12} className="text-center">
              <Title
                regular_text="Unlock Your Business Potential with"
                highlighted_text="Our Professional Website Solutions"
              />
              <Image
                className="img-fluid my-4 hero-banner-img shadow-sm"
                src={require("../../assets/blog/blog-post-1-01.jpg")}
                alt="Website Solutions"
              />
            </Col>
          </Row>

          <Row data-aos="fade-up" data-aos-duration="500" className="my-4">
            <Col xs={12}>
              <p className="lead-text">
                Are you a small or medium-sized business seeking an impressive online
                presence? Whether you're just starting out or looking to revamp your
                existing website, we're here to guide you every step of the way. With
                our extensive industry experience, we've streamlined the website
                building process, ensuring you have a modern and up-to-date website
                in a matter of days. Best of all, you'll be in complete control throughout
                the entire journey.
              </p>
            </Col>
          </Row>

          {/* 4-Step Approach */}
          <div className="approach-section my-5">
            <Row data-aos="fade-up" data-aos-duration="500">
              <Col xs={12} className="text-center mb-5">
                <Title regular_text="Our" highlighted_text="Approach" />
              </Col>
            </Row>

            {/* Step 1 */}
            <Row className="align-items-center mb-5 step-row" data-aos="fade-up" data-aos-duration="500">
              <Col xs={12} md={6} className="order-2 order-md-1 text-md-end">
                <div className="step-content">
                  <h3>1. Selecting the Perfect Style</h3>
                  <p>
                    Let us help you choose the ideal color palette, fonts, and layout
                    that aligns with your brand. We'll even assist in securing a domain
                    if you don't have one yet.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} className="order-1 order-md-2 text-center text-md-start mb-3 mb-md-0">
                <Image
                  src={require("../../assets/blog/blog-post-1-02.png")}
                  className="step-image rounded-circle shadow-sm"
                  alt="Selecting Style"
                />
              </Col>
            </Row>

            {/* Step 2 */}
            <Row className="align-items-center mb-5 step-row" data-aos="fade-up" data-aos-duration="500">
              <Col xs={12} md={6} className="text-center text-md-end mb-3 mb-md-0">
                <Image
                  src={require("../../assets/blog/blog-post-1-03.png")}
                  className="step-image rounded-circle shadow-sm"
                  alt="Content Creation"
                />
              </Col>
              <Col xs={12} md={6} className="text-md-start">
                <div className="step-content">
                  <h3>2. Compelling Content Creation</h3>
                  <p>
                    Collaborate with our experts to craft engaging content for your website,
                    including captivating images and well-crafted text for sections
                    like About Us and Services.
                  </p>
                </div>
              </Col>
            </Row>

            {/* Step 3 */}
            <Row className="align-items-center mb-5 step-row" data-aos="fade-up" data-aos-duration="500">
              <Col xs={12} md={6} className="order-2 order-md-1 text-md-end">
                <div className="step-content">
                  <h3>3. The Finishing Touch</h3>
                  <p>
                    Once all the changes are made, we'll conduct a final review with
                    you to ensure every detail is perfected. Your satisfaction is our
                    top priority.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} className="order-1 order-md-2 text-center text-md-start mb-3 mb-md-0">
                <Image
                  src={require("../../assets/blog/blog-post-1-04.png")}
                  className="step-image rounded-circle shadow-sm"
                  alt="The Finishing Touch"
                />
              </Col>
            </Row>

            {/* Step 4 */}
            <Row className="align-items-center mb-5 step-row" data-aos="fade-up" data-aos-duration="500">
              <Col xs={12} md={6} className="text-center text-md-end mb-3 mb-md-0">
                <Image
                  src={require("../../assets/blog/blog-post-1-05.png")}
                  className="step-image rounded-circle shadow-sm"
                  alt="Publishing"
                />
              </Col>
              <Col xs={12} md={6} className="text-md-start">
                <div className="step-content">
                  <h3>4. Publishing Your Success</h3>
                  <p>
                    In the final step, we'll bring your website online, seamlessly
                    associating it with your chosen domain name.
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="websites_pricing" className="pricing section section-bg py-5">
        <div className="container">
          <Row data-aos="fade-down" data-aos-duration="500">
            <Col xs={12} className="text-center">
              <Title regular_text="Our Tailored" highlighted_text="Plans" />
              <p className="lead-text mx-auto mb-5" style={{ maxWidth: "800px" }}>
                Website development doesn't have to break the bank! We've designed
                four plans to suit your specific needs. Each plan includes a one-time
                cost for building and setting up your website, as well as a hosting
                fee to maintain it on our reliable servers.
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center">
            {/* Basic Plan */}
            <Col xs={12} md={6} lg={3} className="d-flex mb-4" data-aos="fade-up" data-aos-duration="500">
              <div className="price-item d-flex flex-column w-100">
                <div className="price-title text-center">
                  <h3>Basic</h3>
                  <p><strong className="value">$50</strong>/ month</p>
                </div>
                <ul className="price-feature-list flex-grow-1">
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Main page</strong> - $200 one time</li>
                  <li>
                    <FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Included page modules</strong>
                    <ul className="nested-feature-list">
                      <li>About Us</li>
                      <li>Services</li>
                      <li>Social media links</li>
                      <li>Contact Us</li>
                    </ul>
                  </li>
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Up to 10 images</strong></li>
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Up to 2 videos</strong></li>
                </ul>
              </div>
            </Col>

            {/* Silver Plan */}
            <Col xs={12} md={6} lg={3} className="d-flex mb-4" data-aos="fade-up" data-aos-duration="500" data-aos-delay="100">
              <div className="price-item d-flex flex-column w-100">
                <div className="price-title text-center">
                  <h3>Silver</h3>
                  <p><strong className="value">$55</strong>/ month</p>
                </div>
                <ul className="price-feature-list flex-grow-1">
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Basic plan +</strong></li>
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Up to 10 additional pages</strong> - $200/page</li>
                  <li>
                    <FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Included page modules</strong>
                    <ul className="nested-feature-list">
                      <li>Project portfolio</li>
                      <li>Food menu</li>
                      <li>Real estate listings</li>
                      <li>Customer testimonials</li>
                      <li>Contact us message form</li>
                      <li>Posting/Blog pages</li>
                    </ul>
                  </li>
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Up to 30 images</strong></li>
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Up to 5 videos</strong></li>
                </ul>
              </div>
            </Col>

            {/* Gold Plan */}
            <Col xs={12} md={6} lg={3} className="d-flex mb-4" data-aos="fade-up" data-aos-duration="500" data-aos-delay="200">
              <div className="price-item d-flex flex-column w-100">
                <div className="price-title text-center">
                  <h3>Gold</h3>
                  <p><strong className="value">$70</strong>/ month</p>
                </div>
                <ul className="price-feature-list flex-grow-1">
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Silver plan +</strong></li>
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Up to 100 additional pages</strong> - $100/page</li>
                  <li>
                    <FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Included page modules</strong>
                    <ul className="nested-feature-list">
                      <li>Online Scheduling</li>
                      <li>Online Reservations</li>
                    </ul>
                  </li>
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Up to 100 images</strong></li>
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Up to 20 videos</strong></li>
                </ul>
              </div>
            </Col>

            {/* Platinum Plan */}
            <Col xs={12} md={6} lg={3} className="d-flex mb-4" data-aos="fade-up" data-aos-duration="500" data-aos-delay="300">
              <div className="price-item d-flex flex-column w-100">
                <div className="price-title text-center">
                  <h3>Platinum</h3>
                  <p><strong className="value">$100</strong>/ month</p>
                </div>
                <ul className="price-feature-list flex-grow-1">
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Gold plan +</strong></li>
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Unlimited pages</strong> - $50/page</li>
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Online Store module</strong> - depends on complexity</li>
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Up to 1000 images</strong></li>
                  <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> <strong className="value-highlight">Up to 100 videos</strong></li>
                </ul>
              </div>
            </Col>
          </Row>

          <Row data-aos="fade-up" data-aos-duration="500" className="mt-4">
            <Col xs={12} className="text-center">
              <p className="lead-text mx-auto mb-4" style={{ maxWidth: "800px" }}>
                Discover the perfect website solution for your business today.
                By partnering with us, you'll gain peace of mind and take a significant
                step towards achieving online success. Don't hesitate to get in touch with us now!
              </p>
              <Button as={Link} to="/home/contact" size="lg" variant="primary" className="btn-main">
                Contact Us
              </Button>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
}
